import { ISidebarRoutesSectionOption, ISidebarRoutesSubSection } from '@/interfaces/routing/ISidebarRoutes.ts';
import { marketsRoutes } from '../marketsRoutes.ts';

export const marketsSidebarInfo: Array<ISidebarRoutesSectionOption | ISidebarRoutesSubSection> = [
    {
        sectionName: 'Market Summary',
        icon: ['fad', 'chart-bar'],
        pages: [
            {
                name: 'Daily',
                route: marketsRoutes.currentNews.name as string,
                icon: ['fas', 'bolt'],
                availableOnMobile: true,
            },
            {
                name: 'Monthly',
                route: marketsRoutes.monthlySummary.name as string,
                icon: ['fad', 'newspaper'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Market Overview',
                route: marketsRoutes.marketOverview.name as string,
                icon: ['fas', 'chart-line'],
                availableOnMobile: true,
            },
        ],
    },
    {
        name: 'Custom Dashboards',
        route: marketsRoutes.userDashboard.name as string,
        icon: ['fad', 'columns'],
        availableOnMobile: true,
    },
    {
        name: 'Asset monitoring',
        route: marketsRoutes.assetMonitoring.name as string,
        icon: ['fas', 'battery-full'],
        availableOnMobile: true,
        requiresDevDashboardModules: true,
    },
    {
        sectionName: 'Balancing',
        icon: ['fad', 'scale-unbalanced'],
        pages: [
            {
                name: 'BOA Visualiser',
                route: marketsRoutes.boa.name as string,
                icon: ['fad', 'arrow-alt-square-up'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'BM Dashboards',
                route: marketsRoutes.bmDashboards.name as string,
                icon: ['fas', 'ball-pile'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Imbalance',
                route: marketsRoutes.nivEvolution.name as string,
                icon: ['fad', 'scale-unbalanced'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'European Dashboards',
                route: marketsRoutes.europeanBalancingDashboards.name as string,
                icon: ['fad', 'globe-europe'],
                availableOnMobile: true,
            },
        ],
    },
    {
        sectionName: 'Intraday',
        icon: ['fas', 'chart-line'],
        pages: [
            {
                name: 'EPEX M7 Grid',
                route: marketsRoutes.epexGrid.name as string,
                icon: ['fas', 'list'],
                availableOnMobile: true,
                countries: ['Gb', 'France'],
            },
            {
                name: 'EPEX M7 Dashboards',
                route: marketsRoutes.epexDashboards.name as string,
                icon: ['fad', 'columns'],
                availableOnMobile: true,
                countries: ['Gb', 'France'],
            },
            {
                name: 'Market Overview',
                route: marketsRoutes.intradayOverview.name as string,
                icon: ['fas', 'ball-pile'],
                availableOnMobile: true,
            },
            {
                name: 'Trading Overview',
                route: marketsRoutes.intradayTradingOverview.name as string,
                icon: ['fas', 'chart-line'],
                availableOnMobile: true,
            },
        ],
    },
    {
        sectionName: 'Day-Ahead',
        icon: ['fad', 'chart-bar'],
        pages: [
            {
                name: 'Trading Overview',
                route: marketsRoutes.dayAheadTrading.name as string,
                icon: ['fad', 'columns'],
                availableOnMobile: true,
            },
            {
                name: 'Storage DA Analysis',
                route: marketsRoutes.storageDayAheadDashboard.name as string,
                icon: ['fad', 'chart-bar'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
        ],
    },
    {
        sectionName: 'Ancillary',
        icon: ['fas', 'bolt'],
        pages: [
            {
                name: 'Contracts',
                route: marketsRoutes.ancillaryContracts.name as string,
                icon: ['fad', 'file-signature'],
                countries: ['Gb'],
                tags: ['GB'],
                availableOnMobile: true,
            },
            {
                name: 'Prices',
                route: marketsRoutes.ancillaryDashboards.name as string,
                icon: ['fad', 'columns'],
                tags: ['GB'],
                availableOnMobile: true,
                countries: ['Gb'],
            },
        ],
    },
    {
        sectionName: 'Cross-Country Analysis',
        icon: ['fad', 'globe-europe'],
        pages: [
            {
                name: 'Overview',
                route: marketsRoutes.europeOverview.name as string,
                icon: ['fad', 'house'],
                availableOnMobile: true,
            },
            {
                name: 'Cost Analysis',
                route: marketsRoutes.europeanAnalysisView.name as string,
                icon: ['fad', 'chart-mixed'],
                availableOnMobile: true,
            },
            {
                name: 'Market Analysis',
                route: marketsRoutes.valueStreamAnalysis.name as string,
                icon: ['fad', 'chart-line-up'],
                availableOnMobile: true,
            },
            {
                name: 'Wholesale Data',
                route: marketsRoutes.wholesaleData.name as string,
                icon: ['fas', 'bolt'],
                availableOnMobile: true,
            },
            {
                name: 'Map Comparison',
                route: marketsRoutes.europeMap.name as string,
                icon: ['fad', 'globe-europe'],
                availableOnMobile: true,
            },
            {
                name: 'Interconnectors Overview',
                route: marketsRoutes.interconnectorDashboards.name as string,
                icon: ['fas', 'right-left'],
                availableOnMobile: true,
            },
        ],
    },
    {
        sectionName: 'Asset Analysis',
        icon: ['fad', 'lightbulb-on'],
        pages: [
            {
                name: 'Bingo Board',
                route: marketsRoutes.bingoBoard.name as string,
                icon: ['fad', 'th'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Activity Board',
                route: marketsRoutes.plantActivity.name as string,
                icon: ['fas', 'list'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Bingo Map',
                route: marketsRoutes.bingoMap.name as string,
                icon: ['fad', 'map-pin'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Zonal Build-Up',
                route: marketsRoutes.zonalBuildUp.name as string,
                icon: ['fad', 'map-marked-alt'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Unavailability',
                route: marketsRoutes.remit.name as string,
                icon: ['fad', 'brake-warning'],
                availableOnMobile: true,
            },
        ],
    },
    {
        sectionName: 'Forecasting',
        icon: ['fad', 'crystal-ball'],
        pages: [
            {
                name: 'Forecast Evolution',
                route: marketsRoutes.forecastHistory.name as string,
                icon: ['fad', 'history'],
                availableOnMobile: true,
            },
            {
                name: 'Wind',
                route: marketsRoutes.windForecasting.name as string,
                icon: ['fad', 'wind-turbine'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
            {
                name: 'Weather',
                route: marketsRoutes.weatherForecasting.name as string,
                icon: ['fad', 'sun-cloud'],
                availableOnMobile: true,
                countries: ['Gb'],
                tags: ['GB'],
            },
        ],
    },
    {
        sectionName: 'Data Exporters',
        icon: ['fad', 'search'],
        pages: [
            {
                name: 'Historic Exporter',
                route: marketsRoutes.historicAnalysis.name as string,
                icon: ['fad', 'search'],
                availableOnMobile: true,
            },
            {
                name: 'Cross-Country Exporter',
                route: marketsRoutes.crossCountryExporter.name as string,
                icon: ['fad', 'file-export'],
                availableOnMobile: false,
            },
            {
                name: 'API & DPS Instructions',
                route: marketsRoutes.apiInstructions.name as string,
                icon: ['fas', 'code'],
                availableOnMobile: false,
            },
        ],
    },
    {
        name: 'Zonal Map',
        route: marketsRoutes.map.name as string,
        icon: ['fad', 'globe-europe'],
        availableOnMobile: true,
        countries: ['Gb'],
        tags: ['GB'],
    },
    {
        name: 'Market Information',
        route: marketsRoutes.news.name as string,
        icon: ['fad', 'rss'],
        availableOnMobile: true,
        countries: ['Gb'],
    },
    {
        name: 'Notifications',
        route: marketsRoutes.notifications.name as string,
        icon: ['fad', 'bell-on'],
        availableOnMobile: true,
    },
    {
        name: 'Glossary',
        route: marketsRoutes.glossary.name as string,
        icon: ['fad', 'notebook'],
        availableOnMobile: false,
    },
];
